import React from 'react';
import { Checkbox, MeatballMenu, Numberbox } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { ListItem } from 'app/area/shared/list-components/list-item';
import { ListItemHeader } from 'app/area/shared/list-components/list-item-header';
import { ListItemBody } from 'app/area/shared/list-components/list-item-body';

import { getFilterId } from '../utils/get-filter-id';
import { DefaultFiltersTranslation, DefaultFiltersEndpoints } from '../constants';
import { DefaultFilter, DefaultFilterValidation, DefaultFilterMetadata } from '../types-store';
import { DeleteAllFiltersHandler, DeleteFilterHandler, UpdateFilterHandler } from '../types';
import { FilterFactory } from './filter-factory';

import styles from './filter-tile.scss';

interface FilterTileProps {
  filter: DefaultFilter;
  metadata: DefaultFilterMetadata;

  updateFilter: UpdateFilterHandler;
  deleteFilter: DeleteFilterHandler;
  deleteAllFilters: DeleteAllFiltersHandler;

  showRequired: boolean;

  endpoints: DefaultFiltersEndpoints;

  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  locale: string;
  validation: { [domainId: number]: DefaultFilterValidation };
  translation: DefaultFiltersTranslation;
}

export const FilterTile: React.FC<FilterTileProps> = ({
  filter, metadata,
  updateFilter, deleteFilter, deleteAllFilters,
  showRequired, endpoints, options, loadOptions,
  locale, validation, translation
}) => {

  const checkboxId = getFilterId(filter.domain?.value, 'required');

  const onSequenceChange = (value: number) => {

    const { sequence: _, ...filteredValidation } = (validation?.[filter.domain?.value] ?? {});

    updateFilter(
      filter.domain?.value,
      { ...filter, sequence: value },
      filteredValidation
    );
  };

  const onRequiredChange = (value: number) => {

    const { required: _, ...filteredValidation } = (validation?.[filter.domain?.value] ?? {});

    updateFilter(
      filter.domain?.value,
      { ...filter, required: value !== 0 },
      filteredValidation
    );
  };

  const onRemove = () => {
    deleteFilter(filter.domain?.value);
  };

  return <div className="col-lg-6 col-sm-12">
    <div className={styles.tileWrapper}>
      <ListItem>
        <ListItemHeader>
          <h3>{filter.domain?.description}</h3>
          <MeatballMenu closeAfterClick={true}>
            <li>
              <button className="dropdown-item"
                onClick={onRemove}>
                {translation.remove}
              </button>
            </li>
            <li>
              <button className="dropdown-item"
                onClick={deleteAllFilters}>
                {translation.remove_all}
              </button>
            </li>
          </MeatballMenu>
        </ListItemHeader>
        <ListItemBody>
          <Numberbox
            componentId={getFilterId(filter.domain?.value, 'sequence')}
            label={translation ? { text: translation.sequence } : undefined}
            value={filter.sequence}
            onChange={onSequenceChange}
            useThousand=" "
            maxValue={999999999}
            locale={locale}
            validation={validation?.[filter.domain?.value]?.sequence} />
          {!!showRequired && <Checkbox
            className={undefined}
            componentId={checkboxId}
            value={filter.required ? 1 : 0}
            label={{ text: translation.required, visible: true }}
            validation={validation?.[filter.domain?.value]?.required}
            onChange={onRequiredChange} />}
          <FilterFactory
            filter={filter}
            metadata={metadata}
            updateFilter={updateFilter}
            endpoints={endpoints}
            options={options}
            loadOptions={loadOptions}
            validation={validation?.[filter.domain?.value]}
            translation={translation} />
        </ListItemBody>
      </ListItem>
    </div>
  </div>;
};
